import LobbyInvite from "./LobbyInvite";
import "./lobby-invite.scss";

export default LobbyInvite;
